export default "__VITE_ASSET__BM7UU_gb__"